import { gql } from "apollo-angular";
import { PRODUCT_FRAGMENT } from "./product-fragment";

export const getProductByHandle = /* GraphQL */ gql`
    ${PRODUCT_FRAGMENT}
    query GetProductByHandle($handle: String) {
        productByHandle(handle: $handle) {
            ...ProductFields
        }
    }`;